import React from 'react';
import styled from 'styled-components';

// TP: todo: I'm not sure we use this. Deprecated?

const IntroQuestion = ({data}) =>{
    return (
        <FeedbackContainer>
            <Emoji>{data.emoji}</Emoji>
            <QuestionText>{data.title}</QuestionText>
            {data.text.map((item, i)=>{
                return <Description key={i}>{item}</Description>
            })}
        </FeedbackContainer>
    )
}

export default IntroQuestion;


const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width:600px;
  font-family: 'Raleway', sans-serif;
`;

const QuestionText = styled.h2`
  margin-bottom: 1rem;
  color:#2A3039;
  font-size: 20px;
  font-weight: 600;
`;

const Description = styled.div`
color: #2A3039;
font-family: 'Raleway';
font-style: normal;
font-weight: 400;
font-size: 16px;
margin-bottom:26px;
line-height: 150%;
`
const Emoji = styled.div`
    font-size: 48px;
    margin-bottom:24px;
`